module.exports = __webpack_public_path__ + "media/images/icons/payment_methods/Visa-c2cdf0215e0e7e6c708dd95034bebf22.svg";